import { useRouter } from 'next/router';
import React from 'react';

import { Button, Icon, Space } from '@sravni/react-design-system';
import type { ButtonProps } from '@sravni/react-design-system/dist/types/components/Button';
import { Warning } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import { useSelectUser } from '@src/reducers/user';
import { fullDealLandingPageRoute } from '@src/shared/constants/pageRoutes';

import { FULL_DEAL_ENTRY_POINT_TEXTS, FULL_DEAL_WEB_TO_WEB_LINKS, FULL_DEAL_WEB_TO_WEB_SOURCE } from '../../config';
import { buildHasOfferLinkForFullDeal, openMobileApp } from '../../lib';
import { ToFullDealAdvertisingButton } from '../ToFullDealAdvertisingButton/ToFullDealAdvertisingButton';

export interface FullDealOfferActionsProps {
  amount: number;
  term: number;
  hasIssuedMicrocreditDeals: boolean;
  toFullDealButtonText: string;
  toFullDealButtonColor?: ButtonProps['color'];

  seoHeading?: string;

  onMyLoansClick?: (event: React.SyntheticEvent, seoHeading: string) => void;
}

export const FullDealOfferActions = ({
  amount,
  term,
  hasIssuedMicrocreditDeals,
  toFullDealButtonText,
  toFullDealButtonColor = 'dark',
  seoHeading,

  onMyLoansClick = openMobileApp,
}: FullDealOfferActionsProps) => {
  const isMobile = useIsMobile();
  const user = useSelectUser();
  const { asPath } = useRouter();
  const [pathWithoutQuery] = asPath.split('?');
  const isLandingPage = pathWithoutQuery.includes(fullDealLandingPageRoute);

  const linkWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_LINKS.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_LINKS.FROM_REFERAL_VITRINA;

  const sourceWebToWeb = isLandingPage
    ? FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_LANDING
    : FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_REFERAL_VITRINA;

  return (
    <Space direction={isMobile ? 'column' : 'row'} size={8}>
      <ToFullDealAdvertisingButton
        variant="primary"
        link={buildHasOfferLinkForFullDeal({
          link: linkWebToWeb,
          amount,
          term,
          ...(isLandingPage && {
            showAuth: true,
            referrer: asPath,
          }),
        })}
        color={toFullDealButtonColor}
        size={52}
        source={sourceWebToWeb}
        linkTarget="_self"
        block
      >
        {toFullDealButtonText}
      </ToFullDealAdvertisingButton>

      {!user && (
        <Button size={52} block color="dark" onClick={(e) => onMyLoansClick(e, seoHeading)}>
          <Icon color="red" icon={<Warning />} /> {FULL_DEAL_ENTRY_POINT_TEXTS.fakeButtonText}
        </Button>
      )}

      {hasIssuedMicrocreditDeals && (
        <Button size={52} block color="dark" onClick={(e) => onMyLoansClick(e, seoHeading)}>
          {FULL_DEAL_ENTRY_POINT_TEXTS.mobileAppButtonText}
        </Button>
      )}
    </Space>
  );
};
